import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-248b6296"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "template-swipe"
};
const _hoisted_2 = {
  key: 0,
  class: "swiper-wrapper"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_TemplateSwipeItem = _resolveComponent("TemplateSwipeItem");
  const _component_ElCarouselItem = _resolveComponent("ElCarouselItem");
  const _component_ElCarousel = _resolveComponent("ElCarousel");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [$data.swipeArr && $data.swipeArr.length ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createVNode(_component_ElCarousel, {
    "indicator-position": "none",
    arrow: "always",
    onChange: $options.handleChange,
    ref: "carousel",
    height: "auto",
    loop: false,
    autoplay: false
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.swipeArr, (arr, index) => {
      return _openBlock(), _createBlock(_component_ElCarouselItem, {
        key: index
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(arr, (item, idx) => {
          return _openBlock(), _createBlock(_component_TemplateSwipeItem, {
            key: idx,
            "swipe-item": item,
            "item-height": $data.itemHeight,
            "is-mobile": $props.isMobile,
            onNoticeHeight: $options.noticeHeight
          }, null, 8, ["swipe-item", "item-height", "is-mobile", "onNoticeHeight"]);
        }), 128))]),
        _: 2
      }, 1024);
    }), 128))]),
    _: 1
  }, 8, ["onChange"])])) : _createCommentVNode("", true)]);
}